import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import {Auth} from '@aws-amplify/auth';

const entityKey = 'credentials';

const initialState = {
    forcePasswordChange: false,
    loading: false,
    error: '',
};

export const signIn = createAsyncThunk(
    `${entityKey}/signInWithUsernameAndPassword`,
    ({account, username, password}) => {
        Auth.configure({
                           userPoolId: account.cognitoUserPoolId,
                           userPoolWebClientId: account.appClientId,
                       });

        return Auth.signIn(username, password).then(
            (cognitoUser) => cognitoUser
        );
    }
);

const credentialsSlice = createSlice({
                                         name: entityKey,
                                         initialState,
                                         reducers: {
                                             clearError: (state,) => {
                                                 state.loading = true;
                                                 state.error = '';
                                             },
                                         },
                                         extraReducers: (builder) => {
                                             // SIGN IN
                                             builder.addCase(signIn.pending, (state) => {
                                                 state.loading = true;
                                             });

                                             builder.addCase(signIn.fulfilled, (state, action) => {
                                                 const {payload: cognitoUser} = action;

                                                 if (cognitoUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
                                                     state.forcePasswordChange = true;
                                                 }
                                                 // else {
                                                 //     // let id =
                                                 //     //     cognitoUser.signInUserSession.idToken.payload.email.toLocaleLowerCase();
                                                 //     // let record = Object.assign({}, cognitoUser.signInUserSession, {
                                                 //     //     id: id,
                                                 //     // });
                                                 //     // state.byId[record.id] = record;
                                                 //     // state.ids.push(record.id);
                                                 //     // state.totalCount = state.totalCount + 1;
                                                 // }

                                                 state.loading = false;
                                             });

                                             builder.addCase(signIn.rejected, (state, action) => {
                                                 state.loading = false;
                                                 state.error = action.error.message;
                                             });
                                         },
                                     });

export default credentialsSlice.reducer;

export const {clearError} = credentialsSlice.actions;
